import React from 'react';
import {
    LabelBody,
    LabelBodySmall,
    LabelDisplay1,
    Textarea,
} from '../../modules/components';

interface BlueResultBoxProps {
    date: string;
    number: number;
    heading: string;
    description: string[];
    className?: string;
}

export function BlueResultBox({
    date,
    number,
    heading,
    description,
    text,
    setText,
}: BlueResultBoxProps & {
    text?: string;
    setText?: (value: string) => void;
}) {
    return (
        <div className="mt-20 flex flex-col items-center rounded-[20px] bg-[rgba(24,75,205,0.1)] p-20">
            <LabelBodySmall class="mb-10">{date}</LabelBodySmall>

            <div className="bg-blue-600 mb-10 flex h-[40px] w-[40px] items-center justify-center rounded-full bg-[rgba(179,200,255)]">
                <LabelDisplay1 color="text-dark-blue">{number}</LabelDisplay1>
            </div>

            <LabelDisplay1 color="text-dark-blue" class="mb-10">
                {heading}
            </LabelDisplay1>

            {description.map((line, index) => (
                <LabelBody className="mb-10 text-center" key={index}>
                    {line}
                </LabelBody>
            ))}

            {setText && (
                <>
                    <LabelBody class="mt-30 w-full">
                        Er der noget der gør dig særligt presset?
                    </LabelBody>
                    <Textarea
                        text={text}
                        placeholder="Skriv her.."
                        onChangeText={setText}
                    />
                </>
            )}
        </div>
    );
}
